import {initializeApp} from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
import {
    getFirestore,
    collection,
    doc,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    query,
    where,
    orderBy,
    onSnapshot,
} from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBNgAEkm7R32sbOQ8QWIwX-HzzlhZDw598",
    authDomain: "team-ideas.firebaseapp.com",
    projectId: "team-ideas",
    storageBucket: "team-ideas.firebasestorage.app",
    messagingSenderId: "1040110641600",
    appId: "1:1040110641600:web:c8b198506b6b8fa5636825",
    measurementId: "G-KX2TQKC3DB"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const firestore = getFirestore(app);

export {
    collection,
    doc,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    query,
    where,
    orderBy,
    onSnapshot,
};